<div class="h-full min-h-0 overflow-y-auto">
  <div class="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3">
    <div class="inline-flex rounded-lg border border-slate-200 p-1 bg-slate-50">
      @for (tab of TABS; track tab) {
        <button
          type="button"
          (click)="tabSeleccionado.set(tab)"
          class="px-3 py-2 text-sm rounded-md transition-all font-semibold"
          [class.bg-white]="tabSeleccionado() === tab"
          [class.text-slate-900]="tabSeleccionado() === tab"
          [class.shadow-sm]="tabSeleccionado() === tab"
          [class.text-slate-500]="tabSeleccionado() !== tab"
        >
          {{ tab }}
          <span class="ml-1 text-xs text-slate-500"> ({{ totalesPorEstado()[tab] }}) </span>
        </button>
      }
    </div>

    @if (esAdministrador()) {
      <button
        type="button"
        (click)="abrirModalNuevaCampana()"
        class="inline-flex items-center gap-2 bg-blue-600 hover:bg-blue-700 text-white rounded-lg px-4 py-2 text-sm font-semibold transition-colors"
      >
        <i class="bi bi-plus-circle"></i>
        Nueva campaña
      </button>
    }
  </div>

  @if (campanasFiltradas().length > 0) {
    <div class="grid grid-cols-1 lg:grid-cols-2 gap-3">
      @for (campana of campanasFiltradas(); track campana.id) {
        <div class="rounded-xl border border-slate-200 bg-white p-4 shadow-xs space-y-3">
          <div class="flex items-start justify-between gap-3">
            <div>
              <h3 class="text-base sm:text-lg font-bold text-slate-900">{{ campana.nombre }}</h3>
              <p class="text-xs text-slate-500">
                Vigencia: {{ campana.fecha_inicio | date: 'dd/MM/yyyy' }} -
                {{ campana.fecha_fin | date: 'dd/MM/yyyy' }}
              </p>
              <p class="text-xs text-slate-500 mt-1">Sucursal: {{ getNombreSucursal(campana) }}</p>
            </div>
            <span
              class="px-2 py-1 rounded-full text-xs font-semibold"
              [class.bg-emerald-100]="campana.estado === ESTADOS.ACTIVA"
              [class.text-emerald-800]="campana.estado === ESTADOS.ACTIVA"
              [class.bg-amber-100]="campana.estado === ESTADOS.PAUSADA"
              [class.text-amber-800]="campana.estado === ESTADOS.PAUSADA"
              [class.bg-slate-200]="campana.estado === ESTADOS.FINALIZADA"
              [class.text-slate-700]="campana.estado === ESTADOS.FINALIZADA"
            >
              {{ campana.estado }}
            </span>
          </div>

          <div class="space-y-2">
            <p class="text-xs font-semibold text-slate-700">Reglas</p>
            @for (regla of campana.detalles; track $index) {
              <div
                class="rounded-lg border border-slate-100 bg-slate-50 px-3 py-2 text-xs text-slate-700"
              >
                <div class="flex items-center justify-between gap-2">
                  <span class="font-semibold">{{ regla.objetivo_tipo }}</span>
                  <span>
                    {{ regla.tipo_descuento }}:
                    @if (regla.tipo_descuento === 'PORCENTAJE') {
                      {{ regla.valor_descuento | number: '1.2-2' }}%
                    } @else {
                      S/ {{ regla.valor_descuento | number: '1.2-2' }}
                    }
                  </span>
                </div>
                <p class="mt-1">Objetivo: {{ getNombreObjetivo(regla) }}</p>
                <p>Precio mínimo: S/ {{ regla.precio_minimo | number: '1.2-2' }}</p>
              </div>
            }
          </div>

          @if (esAdministrador()) {
            <div class="flex flex-wrap gap-2 pt-2 border-t border-slate-100">
              @if (campana.estado === ESTADOS.ACTIVA) {
                <button
                  type="button"
                  (click)="cambiarEstado(campana.id, ESTADOS.PAUSADA)"
                  class="px-3 py-2 text-xs font-semibold rounded-lg bg-amber-500 hover:bg-amber-600 text-white transition-colors"
                >
                  Pausar
                </button>
              }
              @if (campana.estado === ESTADOS.PAUSADA) {
                <button
                  type="button"
                  (click)="cambiarEstado(campana.id, ESTADOS.ACTIVA)"
                  class="px-3 py-2 text-xs font-semibold rounded-lg bg-emerald-600 hover:bg-emerald-700 text-white transition-colors"
                >
                  Reactivar
                </button>
              }
              @if (campana.estado !== ESTADOS.FINALIZADA) {
                <button
                  type="button"
                  (click)="cambiarEstado(campana.id, ESTADOS.FINALIZADA)"
                  class="px-3 py-2 text-xs font-semibold rounded-lg bg-red-600 hover:bg-red-700 text-white transition-colors"
                >
                  Finalizar (eliminar lógico)
                </button>
              }
            </div>
          }
        </div>
      }
    </div>
  } @else {
    <div
      class="h-full min-h-52 flex items-center justify-center rounded-xl border border-dashed border-slate-300 bg-slate-50"
    >
      <p class="text-slate-500 text-sm">No hay campañas en estado {{ tabSeleccionado() }}.</p>
    </div>
  }
</div>

<app-dialog header="Nueva campaña" [modal]="true" [(visible)]="modalNuevaCampana" size="7xl">
  @if (modalNuevaCampana()) {
    <div class="space-y-4">
      <div class="grid grid-cols-1 md:grid-cols-2 gap-3">
        <div class="space-y-1">
          <label class="text-xs font-semibold text-slate-600">Nombre</label>
          <input
            type="text"
            class="w-full rounded-lg border border-slate-300 px-3 py-2 text-sm outline-none focus:ring-2 focus:ring-blue-200"
            [value]="nuevaCampana().nombre"
            (input)="onNombreChange($any($event.target).value)"
            placeholder="Campaña verano"
          />
        </div>

        <div class="space-y-1">
          <label class="text-xs font-semibold text-slate-600">Sucursal (opcional)</label>
          <app-select
            class="w-full"
            [options]="sucursalesOptions()"
            [value]="nuevaCampana().sucursal_id"
            (onChange)="onSucursalChange($event)"
            [filter]="sucursales().length > 10"
            filterBy="label"
            [showClear]="true"
            emptyFilterMessage="No se encontraron sucursales."
            placeholder="Todas las sucursales"
          />
        </div>

        <div class="space-y-1">
          <label class="text-xs font-semibold text-slate-600">Fecha inicio</label>
          <input
            type="date"
            class="w-full rounded-lg border border-slate-300 px-3 py-2 text-sm outline-none focus:ring-2 focus:ring-blue-200"
            [value]="nuevaCampana().fecha_inicio"
            (input)="onFechaInicioChange($any($event.target).value)"
          />
        </div>

        <div class="space-y-1">
          <label class="text-xs font-semibold text-slate-600">Fecha fin</label>
          <input
            type="date"
            class="w-full rounded-lg border border-slate-300 px-3 py-2 text-sm outline-none focus:ring-2 focus:ring-blue-200"
            [value]="nuevaCampana().fecha_fin"
            (input)="onFechaFinChange($any($event.target).value)"
          />
        </div>
      </div>

      <div class="space-y-2">
        <div class="flex items-center justify-between">
          <h4 class="text-sm font-bold text-slate-800">Reglas de descuento</h4>
          <button
            type="button"
            class="px-3 py-1.5 rounded-lg bg-slate-700 hover:bg-slate-800 text-white text-xs font-semibold"
            (click)="agregarRegla()"
          >
            + Agregar regla
          </button>
        </div>

        <div class="space-y-2 max-h-[45vh] overflow-auto pr-1">
          @for (regla of nuevaCampana().reglas; track $index; let i = $index) {
            <div class="rounded-xl border border-slate-200 p-3 bg-slate-50 space-y-2">
              <div class="grid grid-cols-1 md:grid-cols-5 gap-2">
                <div>
                  <label class="text-xs text-slate-600 font-semibold">Objetivo</label>
                  <app-select
                    class="w-full text-sm"
                    [options]="tiposObjetivoOptions()"
                    [value]="regla.objetivo_tipo"
                    (onChange)="onReglaObjetivoTipoChange(i, $event)"
                    placeholder="Selecciona objetivo"
                  />
                </div>

                <div>
                  <label class="text-xs text-slate-600 font-semibold">
                    @if (regla.objetivo_tipo === 'PRODUCTO') {
                      Producto
                    } @else {
                      Categoría
                    }
                  </label>

                  @if (regla.objetivo_tipo === 'PRODUCTO') {
                    <app-select
                      class="w-full"
                      [options]="productosOptions()"
                      [value]="regla.producto_id"
                      (onChange)="onReglaProductoChange(i, $event)"
                      [filter]="true"
                      filterBy="label"
                      [showClear]="true"
                      emptyFilterMessage="No se encontraron productos."
                      placeholder="Buscar producto..."
                    />
                  } @else {
                    <app-select
                      class="w-full"
                      [options]="categoriasOptions()"
                      [value]="regla.categoria_id"
                      (onChange)="onReglaCategoriaChange(i, $event)"
                      [filter]="categorias().length > 10"
                      filterBy="label"
                      [showClear]="true"
                      emptyFilterMessage="No se encontraron categorías."
                      placeholder="Selecciona categoría"
                    />
                  }
                </div>

                <div>
                  <label class="text-xs text-slate-600 font-semibold">Tipo descuento</label>
                  <app-select
                    class="w-full text-sm"
                    [options]="tiposDescuentoOptions()"
                    [value]="regla.tipo_descuento"
                    (onChange)="onReglaTipoDescuentoChange(i, $event)"
                  />
                </div>

                <div>
                  <label class="text-xs text-slate-600 font-semibold">Valor</label>
                  <input
                    type="number"
                    step="0.01"
                    min="0"
                    [ngModel]="regla.valor_descuento"
                    [ngModelOptions]="{ standalone: true }"
                    (input)="onReglaValorDescuentoChange(i, $any($event.target).value)"
                    class="w-full rounded-lg border border-slate-300 bg-white px-3 py-2 text-sm outline-none transition focus:border-blue-400 focus:ring-2 focus:ring-blue-100 appearance-none"
                    placeholder="0.00"
                  />
                </div>

                <div>
                  <label class="text-xs text-slate-600 font-semibold">Precio mínimo</label>
                  <input
                    type="number"
                    step="0.01"
                    min="0"
                    [ngModel]="regla.precio_minimo"
                    [ngModelOptions]="{ standalone: true }"
                    (input)="onReglaPrecioMinimoChange(i, $any($event.target).value)"
                    class="w-full rounded-lg border border-slate-300 bg-white px-3 py-2 text-sm outline-none transition focus:border-blue-400 focus:ring-2 focus:ring-blue-100 appearance-none"
                    placeholder="0.00"
                  />
                </div>
              </div>

              <div class="flex justify-end">
                <button
                  type="button"
                  (click)="eliminarRegla(i)"
                  [disabled]="nuevaCampana().reglas.length === 1"
                  class="text-xs px-3 py-1.5 rounded-lg bg-red-50 text-red-700 hover:bg-red-100 disabled:opacity-50 disabled:cursor-not-allowed"
                >
                  Eliminar regla
                </button>
              </div>
            </div>
          }
        </div>
      </div>

      <div class="pt-2 border-t border-slate-200 flex justify-end gap-2">
        <button
          type="button"
          class="px-4 py-2 rounded-lg bg-slate-200 text-slate-800 text-sm font-semibold hover:bg-slate-300"
          (click)="cerrarModalNuevaCampana()"
        >
          Cancelar
        </button>
        <button
          type="button"
          class="px-4 py-2 rounded-lg bg-blue-600 text-white text-sm font-semibold hover:bg-blue-700"
          (click)="crearCampana()"
        >
          Crear campaña +
        </button>
      </div>
    </div>
  }
</app-dialog>
